async function applyCardArtwork(viewer) {
  const materials = new Map(viewer.model.materials.map((material) => [material.name, material]));
  const textures = new Map();

  const getTexture = async (url) => {
    const absoluteUrl = new URL(url, window.location.href).href;
    if (!textures.has(absoluteUrl)) textures.set(absoluteUrl, viewer.createTexture(absoluteUrl));
    return textures.get(absoluteUrl);
  };

  const setTexture = async (materialName, url) => {
    const material = materials.get(materialName);
    if (!material || !url) return;
    const texture = await getTexture(url);
    material.pbrMetallicRoughness.baseColorTexture.setTexture(texture);
  };

  await Promise.all([
    setTexture('Front artwork', viewer.dataset.modelFrontSrc),
    setTexture('Back artwork', viewer.dataset.modelBackSrc),
    setTexture('Disc artwork front', viewer.dataset.modelDiscSrc),
    setTexture('Disc artwork back', viewer.dataset.modelDiscSrc),
  ]);
}

function initializeCardModel(viewer) {
  const card = viewer.closest('.yv-card-wrapper--model');
  if (!card) return;

  const activate = () => {
    if (!viewer.hasAttribute('src')) viewer.setAttribute('src', viewer.dataset.modelSrc);
    viewer.setAttribute('auto-rotate', '');
  };

  const deactivate = () => {
    viewer.removeAttribute('auto-rotate');
  };

  viewer.addEventListener('load', async () => {
    try {
      if (viewer.dataset.modelDynamicArtwork === 'true') await applyCardArtwork(viewer);
      if (viewer.hasAttribute('src')) card.classList.add('yv-model-ready');
    } catch {
      card.classList.remove('yv-model-ready');
    }
  });
  viewer.addEventListener('error', () => card.classList.remove('yv-model-ready'));
  card.addEventListener('pointerenter', activate);
  card.addEventListener('pointerleave', deactivate);
  card.addEventListener('focusin', activate);
  card.addEventListener('focusout', deactivate);
}

function initializeCardModels() {
  document.querySelectorAll('.yv-card-model').forEach(initializeCardModel);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCardModels, { once: true });
} else {
  initializeCardModels();
}
